// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.90.0-beta.100e30845',
  revision: '100e30845',
  branch: 'develop',
  date: 'Thu, 06 Aug 2026 15:34:28 GMT'
};